import {
  CONTACT_REQUEST,
  CONTACT_SUCCESS,
  CONTACT_FAIL,
  CONTACT_RESET,
  CONTACT_CLEAR_ERRORS,
} from "../constants/contactConstants";

export const contactReducer = (state = {}, action) => {
  switch (action.type) {
    case CONTACT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload && action.payload,
      };
    case CONTACT_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload && action.payload,
      };
    case CONTACT_RESET:
      return {
        ...state,
        success: false,
      };
    case CONTACT_CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
